import React from 'react';
import { useLocation } from 'react-router-dom';
import { ReactComponent as NoResult } from '../../images/NoActivityFound.svg';
import { useTranslation } from 'react-i18next';

export default function DisabledActivityPage() {
    const { t } = useTranslation();
    const location = useLocation();

    return (
        <div className="col-md-12" style={{ height: "100%", display: "flex", alignItems: "center", flexDirection: "column", padding: 25 }}>
            <div style={{ marginTop: 90, height: "631px", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                <NoResult />
                <div style={{ fontSize: 20, lineHeight: 1.4, marginTop: 50 }}>
                    {t("poll.unsupportedActivityTitle")}
                </div>
                <h4 style={{ color: "#666666", fontSize: 15, textAlign: "center", marginTop: 25 }}>
                    {t("poll.unsupportedActivityReleaseDesc")}
                    {location?.state?.fromJoinPage && t("poll.unsupportedActivityJoinDesc")}
                </h4>
            </div>
        </div>
    );
}